import React from "react";
import { withRouter } from "react-router-dom";

function ThankYouScreen(props) {
  const { requestData, handleOpenChat } = props;
  const { id } = requestData.request;
  return (
    <>
      <div className="row">
        <div className="col-0 col-sm-2 col-md-2 col-xl-3"></div>
        <div className="col-12 col-sm-8 col-md-8 col-xl-5">
          <div className="form-box-wrapper">
            <>
              <span
                className="mt-3 mb-4 black-bold-15"
                style={{ paddingBottom: 60 }}
                id="change-filter-title"
              >
                Thank you! Payment of the request #{id} was successful.
              </span>
              <div className="row">
                <div className="col-12 col-sm-6 pt-2">
                  <button
                    type="button"
                    className="red-btn custom-buton custom-buton-large w-100"
                    onClick={handleOpenChat}
                  >
                    chat
                  </button>
                </div>
                <div className="col-12 col-sm-6 pt-2">
                  <button
                    type="button"
                    className="custom-buton custom-buton-large custom-button-pink w-100"
                    onClick={() =>
                      props.history.push("/dashboard/my-requests/" + id)
                    }
                  >
                    Request details
                  </button>
                </div>
              </div>
            </>
          </div>
        </div>
        <div className="col-0 col-sm-2 col-md-2 col-xl-4"></div>
      </div>
    </>
  );
}

export default withRouter(ThankYouScreen);
